import { css } from '@compiled/react';
import { useIntl } from 'react-intl';

import { Checkbox } from '@atlaskit/checkbox';
import { token } from '@atlaskit/tokens';

import { checkFeatureFlagGate } from '@/utils/feature-flags/check-feature-flag';
import { featureFlags } from '@/utils/feature-flags/feature-flag-manifest';

import { PRIMARY_BLACK } from '../constants';

const wrapperStyles = css({
	padding: '19px 16px',
	// eslint-disable-next-line local/ensure-wac-token-usage
	border: '2px #DCDFE4 solid !important',
	borderRadius: '8px',
	minWidth: '400px',
	cursor: 'pointer',
	display: 'flex',
	alignItems: 'center',
	'&:hover': {
		// eslint-disable-next-line local/ensure-wac-token-usage
		borderColor: '#0C66E4 !important',
	},
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
	label: {
		alignItems: 'center',
		cursor: 'pointer',
		textAlign: 'left',
	},
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
	'label span': {
		margin: '0 auto 0 4px',
		cursor: 'pointer',
	},
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
	input: {
		cursor: 'pointer',
	},
});

const labelStyles = css({
	fontFamily: 'var(--atlassian-sans-font-family)',
	fontWeight: 600,
	color: `${PRIMARY_BLACK}`,
	fontSize: '1rem',
	lineHeight: '1.2rem',
	textAlign: 'left',
});

const visualFeedbackWrapperStyles = css({
	borderWidth: '1px',
	borderStyle: 'solid',
	borderColor: token('color.border'),
	borderRadius: '6px',
});

const visualFeedbackCheckedStyles = css({
	borderWidth: '2px',
	borderStyle: 'solid',
	borderColor: token('color.border.focused'),
});

const visualFeedbackLabelStyles = css({
	color: `${token('color.text')}`,
});

const JtbdCheckbox = ({
	name,
	id,
	isChecked,
	handleClick,
	isDisabled,
}: {
	name: string;
	id: string;
	isChecked: boolean;
	handleClick: () => void;
	isDisabled: boolean;
}) => {
	const intl = useIntl();
	const visualFeedback = checkFeatureFlagGate(featureFlags.signupVisualAlignmentFeedback);
	return (
		<label
			htmlFor={id}
			css={[
				wrapperStyles,
				visualFeedback && visualFeedbackWrapperStyles,
				// eslint-disable-next-line local/ensure-wac-token-usage
				isChecked === true &&
					css({
						borderColor: `${token('color.border.focused')} !important`,
					}),
				visualFeedback && isChecked && visualFeedbackCheckedStyles,
			]}
		>
			<Checkbox
				value={name}
				id={id}
				name={name}
				label={
					<span css={[labelStyles, visualFeedback && visualFeedbackLabelStyles]}>
						{intl.formatMessage({
							id: id,
							defaultMessage: name,
						})}
					</span>
				}
				isChecked={isChecked}
				isDisabled={isDisabled}
				onChange={() => {
					handleClick();
				}}
			/>
		</label>
	);
};

export default JtbdCheckbox;
